var map = {
	"./gs/NewUi": 917,
	"./gs/NewUi.js": 917,
	"./gs/OldUi": 918,
	"./gs/OldUi.js": 918,
	"./spireon/SpireonNew": 919,
	"./spireon/SpireonNew.js": 919,
	"./spireon/SpireonOld": 920,
	"./spireon/SpireonOld.js": 920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2651;